module.exports = __webpack_public_path__ + "static/media/blog-icon.7e738628.svg";